"use client";

import { ShoppingCartIcon } from "@phosphor-icons/react/dist/ssr/ShoppingCart";
import { useEffect } from "react";

import { ProfileType, applicationIsDenied, sync, useProfile } from "@up/data";
import { LoadingError, LoadingModal, UPLink } from "@up/ui";

import { AppStatus } from "./application-status";
import { EditProfileEmail } from "./edit-profile-email";
import { EditProfilePersonalInfo } from "./edit-profile-personal-info";
import { LineItem } from "../line-item";
import { ScholarshipStatusView } from "./scholarship-status";

export function EditProfilePage({
  showPhone = false,
}: {
  showPhone?: boolean;
}) {
  const profile = useProfile();

  useEffect(() => {
    if (profile.isLoading) return;
    sync();
  }, []);

  if (profile?.isLoading) {
    return (
      <div>
        <LoadingModal />
      </div>
    );
  }

  if (profile?.didError) {
    return (
      <div className="mb-8">
        <LoadingError
          error="Sorry, we could not load your profile"
          errorCode={profile.errorCode}
        />
      </div>
    );
  }

  if (profile?.data) {
    return (
      <div>
        <div className="flex flex-col gap-10 lg:gap-16">
          {!("type" in profile.data) ? (
            <AppStatus isStudent={true} />
          ) : profile.data.type === ProfileType.Student ? (
            <div>
              <AppStatus
                isStudent={true}
                status={profile.contact?.application?.status}
              />
              {applicationIsDenied(
                profile.contact?.application?.status,
              ) ? null : (
                <ScholarshipStatusView
                  targetContact={profile.contact}
                  authenticatedProfileType={profile.data.type}
                  status={profile.contact?.scholarship?.status}
                />
              )}
              {applicationIsDenied(
                profile.contact?.application?.status,
              ) ? null : (
                <LineItem
                  compact={true}
                  as={UPLink}
                  href="/checkout"
                  Icon={ShoppingCartIcon}
                >
                  <div className="underline">Enroll</div>
                </LineItem>
              )}
            </div>
          ) : null}

          <EditProfileEmail profile={profile.data} />

          {"type" in profile.data ? (
            <EditProfilePersonalInfo
              showPhone={showPhone}
              profile={profile.data}
            />
          ) : null}
        </div>
      </div>
    );
  }

  return <div />;
}
